import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        component: () =>
            import ('@/views/home.vue'),
        name: 'Home'
    },
    {
        path: '/wap',
        component: () =>
            import ('@/views/wap.vue'),
        name: 'wap'
    },
]

const router = new VueRouter({
    routes
})

export default router